<script setup lang="ts">
import { UserManagement } from '@/components/users';
</script>

<template>
  <div class="activity-container">
    <UserManagement />
  </div>
</template>

<style scoped lang="scss">
.activity-container {
  height: 100%;
}
</style>
